import { FC } from 'react';
import { DropdownMenu } from '@cld/dropdown-menu';
import { ApplicationsDropdownMenuProps } from './ApplicationsDropdownMenu.types';

export const ApplicationsDropdownMenu: FC<ApplicationsDropdownMenuProps> = ({ trigger, placement = 'bottomLeft', ...rest }) => (
  <div data-test="applications-menu" data-test-specifier="application-menu">
    <DropdownMenu minWidth="lg" placement={placement} {...rest}>
      {trigger}
    </DropdownMenu>
  </div>
);
